"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Flatten array of arrays to single array
 * @param listOfArrays
 * @returns {*[]}
 */
var _default = function _default(listOfArrays) {
  return [].concat.apply([], listOfArrays);
};

exports["default"] = _default;